import { render, staticRenderFns } from "./decorate_template_pc.vue?vue&type=template&id=a028769a"
import script from "./decorate_template_pc.vue?vue&type=script&lang=js"
export * from "./decorate_template_pc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports